<mat-dialog-content class="outlet-selection-wrapper">
  <img class="outlet-marker-img" [src]="DEPLOY_URL + (isMobile ? '/assets/images/outlet-selection.svg' : '/assets/images/outlet-selection-desktop.svg')" />

  <div class="address-container">
    <span class="title">
      Please confirm your preference
    </span>
    @if (nearbyOutlets.length) {
      <form class="outlet-selection-form" #addressSelectionForm="ngForm">
        @for (outlet of nearbyOutlets; track outlet) {
          <div class="address-option" [class.disabled]="!outlet.serviceable">
            <label [for]="outlet.outlet_name + outlet.service_type" class="option-label">
              <div style="display: flex; gap: 8px">
                <span class="type-text">
                  {{ outlet.type_label }}
                </span>
                @if (!outlet.serviceable) {
                  <span class="close-text center">CURRENTLY CLOSED</span>
                }
              </div>
              @if (outlet.type_desc) {
                <span class="outlet-name">
                  {{ outlet.type_desc }}
                  @if (outlet.oa) {
                    <img src="{{ DEPLOY_URL }}/assets/images/discount-fill.svg" />
                  }
                </span>
              }
            </label>
            @if (outlet.serviceable) {
              <input class="radio-btn" type="radio" [id]="outlet.outlet_name + outlet.service_type"
                name="selected_outlet" [value]="outlet" required ngModel />
            }
          </div>
        }
        @if (outsideOutlet?.type_label) {
          <span (click)="outsideLocation()" class="outside-location">
            {{ outsideOutlet.type_label }}
          </span>
        }
      </form>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button class="confirm-cta" [class.disabled]="!addressSelectionForm?.valid" type="submit" (click)="onConfirm()">
    Confirm
  </button>
</mat-dialog-actions>
